<template>
    <div class="visualisation-export">
        <button
            v-for="option of printOptions"
            :key="option"
            class="primary field visualisation-export__button"
            :class="{'visualisation-export__button--full': option === 'img'}"
            @click="runExport(option)"
        >
            {{ $t[option] }}
        </button>
    </div>
</template>

<script>
import VisualisationService from '@/services/visualisation.service'

export default {
    name: 'VisualisationExport',
    emits: [
        'print'
    ],
    computed: {
        printOptions() {
            return VisualisationService.getSettingsOptions('export');
        },
        invertColors() {
            return VisualisationService.getInvertColors();
        },
    },
    methods: {
        runExport(type) {
            if (type === 'img') {
                VisualisationService.exportImage(this.invertColors);
            } else if (type === 'webm' || type === 'mp4') {
                VisualisationService.openRecorder(type);
            }
        }
    }
}

</script>

<style lang="scss">
.visualisation-export {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;

    &__button {
        margin: 0 !important;
    }

    &__button--full {
        grid-column: 1 / -1;
    }
}
</style>
